import React from 'react';
import PropTypes from 'prop-types';
import AdvertForm from "components/AdvertForm/AdvertForm";
import {FormattedMessage} from "react-intl";
import {Config} from 'app.config';

class CreateAdvert extends React.Component {
    static propTypes = {
        onAdvertFormSubmit: PropTypes.func.isRequired,
        serviceTypeValues: PropTypes.array.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        onLogout: PropTypes.func.isRequired,
        canHaveHappyHours: PropTypes.bool,
    };

    render() {
        const {onAdvertFormSubmit, serviceTypeValues, priceValuesSms, priceValuesVoice, onLogout, canHaveHappyHours} = this.props;

        return (
            <div className="form text-center">
                <h1>
                    <strong>Placene</strong>volani.cz
                </h1>
                <div className="mt-5 advert-create">
                    <h2 className="font-weight-normal">
                        <FormattedMessage id="advert.new.start.title" defaultMessage="Start with profile creation"/>
                    </h2>
                    <p>
                        <FormattedMessage id="advert.new.start.text"
                                          defaultMessage="Profile is your service description and is meant as propagation for your customers"/>
                    </p>
                </div>

                <AdvertForm priceValuesSms={priceValuesSms} priceValuesVoice={priceValuesVoice}
                            onAdvertFormSubmit={onAdvertFormSubmit} serviceTypeValues={serviceTypeValues}
                            canHaveHappyHours={canHaveHappyHours}
                />

                <div className="help-box">
                    <FormattedMessage id="need_help.text" defaultMessage="Need help? Call us." />
                    <p className="help-box__number">{Config.help_number}</p>
                </div>

                <div>
                    <a tabIndex={-1} onClick={onLogout} className="clickable" >
                        <FormattedMessage id="nav.logout" defaultMessage="Logout" />
                    </a>
                </div>
            </div>
        )
    }
}

export default CreateAdvert;


// WEBPACK FOOTER //
// ./src/containers/InitialAdvertCreator/CreateAdvert.jsx